import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

interface MultiSelectProps {
  options: string[];
  optionsSelected: string[];
  setOptionsSelected: (options: string[]) => void;
  placeholder?: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MultiSelect = ({
  options,
  optionsSelected,
  setOptionsSelected,
  placeholder,
}: MultiSelectProps) => {
  const handleChange = (event: SelectChangeEvent<typeof optionsSelected>) => {
    const {
      target: { value },
    } = event;
    setOptionsSelected(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel>{placeholder ?? ''}</InputLabel>
        <Select
          labelId={placeholder}
          multiple
          value={optionsSelected}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
              },
            },
          }}
        >
          {options.map((optionValue) => (
            <MenuItem key={optionValue} value={optionValue}>
              <Checkbox checked={optionsSelected.indexOf(optionValue) > -1} />
              <ListItemText primary={optionValue} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelect;
